import { CSSProperties } from "react";
import { ImageStyle, StyleProp, StyleSheet, TextProps, View } from "react-native";
import { SLImage } from "src/components";
import { PdButton, PdButtonLabel, tPdButtonProps } from "src/components/forms/button";
import { PdIconButton, tPdIconButtonProps } from "src/components/forms/icon-button";
import { PdText } from "src/components/layout";
import { kColors } from "src/kColors";
import { kStyleConst } from "src/kStyle";

const getFirstLetters = (value?: string) => {
  const words = value?.split(" ");
  return `${words?.[0]?.[0] ?? ""}${words?.[1]?.[0] ?? ""}`;
};

export const ComposerToolbarIconButton: React.FC<tPdIconButtonProps> = (props) => (
  <PdIconButton size="sm" variant="ghost" contentContainerStyle={styles.composerToolbarIconButton} {...props} />
);

export const ComposerToolbarButton: React.FC<tPdButtonProps> = ({ style, ...rest }) => (
  <PdButton size="sm" variant="ghost" contentContainerStyle={[styles.composerToolbarButton, style]} {...rest} />
);

export const ComposerToolbarButtonLabel: React.FC<TextProps> = ({ style, ...rest }) => (
  <PdButtonLabel style={[styles.composerToolbarButtonLabel, style]} {...rest} />
);

export const Avatar: React.FC<{
  uri?: string;
  name?: string;
  size?: "md" | "lg";
  webStyle?: CSSProperties;
  mobileStyle?: StyleProp<ImageStyle>;
}> = ({ name, uri, size = "md", webStyle, mobileStyle }) => {
  if (uri) {
    return (
      <SLImage
        source={{ uri }}
        defaultSource={{ uri }}
        mobileStyle={[styles.avatar, size === "md" ? styles.avatarMd : styles.avatarlg, mobileStyle]}
        webStyle={{ ...styles.avatar, ...(size === "md" ? styles.avatarMd : styles.avatarlg), ...webStyle }}
      />
    );
  }

  return (
    <View style={[styles.avatar, styles.center, size === "md" ? styles.avatarMd : styles.avatarlg, mobileStyle]}>
      <PdText style={[styles.avatarLabel, size === "md" ? styles.avatarLabelMd : styles.avatarLabelLg]}>
        {getFirstLetters(name)}
      </PdText>
    </View>
  );
};

const styles = StyleSheet.create({
  avatar: {
    backgroundColor: kColors.brandPink2,
    borderRadius: 999,
  },
  avatarLabel: {
    color: kColors.white,
    fontWeight: "600",
    textAlign: "center",
    width: "100%",
  },
  avatarLabelLg: {
    fontSize: 22,
  },
  avatarLabelMd: {
    fontSize: 16,
  },
  avatarMd: {
    height: 35,
    width: 35,
  },
  avatarlg: {
    height: 52,
    width: 52,
  },
  center: {
    alignItems: "center",
    justifyContent: "center",
  },
  composerToolbarButton: {
    height: 35,
    minWidth: "auto",
    paddingHorizontal: 2 * kStyleConst.kSpacing,
  },
  composerToolbarButtonLabel: {
    color: kColors.gray500,
    fontSize: 8,
  },
  composerToolbarIconButton: {
    height: 35,
    width: 35,
  },
});
